module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("请选择购买类型")]), _vm._v(" "), _c('van-radio-group', {
    model: {
      value: (_vm.buyType),
      callback: function($$v) {
        _vm.buyType = $$v
      },
      expression: "buyType"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": '购买单张' + '(' + _vm.row.photo_service_price + '元)',
      "label": "支付后仅可下载当前单张图片",
      "clickable": ""
    },
    on: {
      "click": function($event) {
        _vm.buyType = '1'
      }
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-radio', {
          attrs: {
            "checked-color": "#ffad19",
            "name": "1"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": '购买当前赛区所有照片' + '(' + _vm.row.photo_service_allprice + '元)',
      "label": "支付后可下载该赛区所有图片",
      "clickable": ""
    },
    on: {
      "click": function($event) {
        _vm.buyType = '2'
      }
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-radio', {
          attrs: {
            "checked-color": "#ffad19",
            "name": "2"
          }
        })]
      },
      proxy: true
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定支付")])], 1)], 1), _vm._v(" "), _c('PayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "scene": "activity_pic",
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22ad88a7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/activity/ActivityPicOrderForm.vue
// module id = 2272
// module chunks = 0